export const Role = {
    admin: "admin",
    restricted: "restricted",
};